var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_2813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2565 3.55343C24.8741 3.17029 24.2535 3.16963 23.871 3.55181L12.1155 15.2763L7.87412 10.6698C7.50763 10.2719 6.888 10.2461 6.48952 10.6126C6.09134 10.9791 6.06585 11.599 6.43234 11.9972L11.3645 17.3536C11.5451 17.55 11.7979 17.664 12.0645 17.6695C12.0716 17.6698 12.0786 17.6698 12.0854 17.6698C12.3444 17.6698 12.5936 17.5669 12.7772 17.384L25.2546 4.93931C25.6381 4.55718 25.6387 3.93658 25.2565 3.55343Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0201 12.0201C24.4788 12.0201 24.0402 12.4587 24.0402 13C24.0402 19.0878 19.0878 24.0402 13 24.0402C6.91255 24.0402 1.9598 19.0878 1.9598 13C1.9598 6.91255 6.91255 1.9598 13 1.9598C13.5412 1.9598 13.9799 1.52115 13.9799 0.979926C13.9799 0.438648 13.5412 0 13 0C5.83172 0 0 5.83172 0 13C0 20.168 5.83172 26 13 26C20.168 26 26 20.168 26 13C26 12.4588 25.5614 12.0201 25.0201 12.0201Z",
    fill: "#28B446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_2813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4ab79834ced48088a7b8140e24165f17.svg";
export { ForwardRef as ReactComponent };